import React, { useEffect } from "react";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function Disclaimer() {
  useEffect(() => {
      document.title = "Disclaimer| Terms and Conditions Policy";
    }, []);
  return (
    <>
    <Helmet>
      <title>Disclaimer| Terms and Conditions Policy</title>
      <meta name="description" content="Check our disclaimer for transparent insights into our services and limitations. Understand the terms and conditions to make better decisions regarding your hosting needs." />
      <meta name="keywords" content="disclaimer, legal disclaimer, website disclaimer, liability disclaimer" />
      <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/disclaimer`} />
      <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/disclaimer`} />
      <meta property="og:title" content="Disclaimer| Terms and Conditions Policy" />
      <meta property="og:description" content="Check our disclaimer for transparent insights into our services and limitations. Understand the terms and conditions to make better decisions regarding your hosting needs." />
    </Helmet>

    <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8">
              <div className="text-center">
                  <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Disclaimer
                    </h1>
                  <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Stay informed and make informed decisions. Read our disclaimer to learn about the terms and conditions governing the use of our website and the information provided.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="pt-100 pb-100 position-relative z-1 overflow-hidden">
        <div className="container">
            <h3 className="text-center mb-5">Your Trusted Provider of Independent Cloud Web Hosting Solutions</h3>
          <p className="text-center">
            Infinitive Host Technologies Pvt Ltd is an independent web hosting
            service provider that specializes in cloud-based platform
            alternatives and server management. Any third-party brand name is
            not affiliated with or endorsed by the company. If any brand name,
            product, or image is mentioned on the website, it is only for
            reference purposes unless the organization expressly states
            otherwise. The services we provide are only available through our
            official website.
          </p>
        </div>
      </section>
    </>
  );
}
